import React from 'react';
import PropTypes from 'prop-types';
import {DragSource, DropTarget} from 'react-dnd';
import DragDropItemType from "../../common/drag-and-drop/DragDropItemType";
import Row from "./Row";
import {collectSource, collectTarget, rowSource, rowTarget} from "./DragDropEngine";

const propTypes = {
	// provided by DragSource/DragTarget HOC
	connectDragSource: PropTypes.func.isRequired,
	connectDropTarget: PropTypes.func.isRequired,
	...Row.propTypes,
};

const defaultProps = {
	...Row.defaultProps,
};

class DragDropRow extends React.Component {
	render() {
		return <Row {...{...this.props, isDragDrop: true}}/>;
	}
}

DragDropRow.defaultProps = defaultProps;
DragDropRow.propTypes = propTypes;

export default DropTarget(DragDropItemType.TABLE_ROW, rowTarget, collectTarget)(DragSource(DragDropItemType.TABLE_ROW, rowSource, collectSource)(DragDropRow));
